import React from 'react';
import { Stack, rem } from '@mantine/core';
import { MainContentContainer } from '@clinicaltoolkits/universal-react-components';

export const Main: React.FC = () => {
  return (
    <MainContentContainer>
      <Stack gap={rem(20)} w={"100%"} align='center' justify='center'>
        <h1 style={{ color: '#4CAF50' }}>Welcome to AI Live</h1>
        <p style={{ fontSize: '1.2em' }}>
          We're currently working on a new version of the AI Live website. Please check back next week for updates!
        </p>
      </Stack>
    </MainContentContainer>
  );
}

/*Supporting those who support others*/

